import RangeDatePicker from './DatePicker';

export default RangeDatePicker;
